import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ShippingAddressBook from '../components/ShippingAddressBook';

const AddressSettings: React.FC = () => {
  const { user } = useAuth();
  if (!user) return <div>Loading...</div>;

  return (
    <div>
      <h1 className="page-title" style={{ marginBottom: '32px' }}>Shipping Address Management</h1>
      <ShippingAddressBook userId={user.id} />
    </div>
  );
};

export default AddressSettings;
